module.exports = __webpack_public_path__ + "img/logo_pracevplzni.54bcb33.svg";